var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampCableway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 4,
    d: "M5 10h38M24 10v8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#080908",
    strokeWidth: 3,
    d: "M12 18h24l4 18-6 6H14l-6-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181916",
    d: "M15 24h7v8h-7zm11 0h7v8h-7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#59d0ce",
    strokeWidth: 3,
    d: "M15 37h18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampCableway);
export default __webpack_public_path__ + "static/media/camp-cableway.71769f3d08c27dd5415f43545b87ec1c.svg";
export { ForwardRef as ReactComponent };